import PIE_BOMB_SPLAT_IMAGE_URL from './pieSplat.png';
export { PIE_BOMB_SPLAT_IMAGE_URL };
export const PIE_BOMB_SPLAT_SPRITESHEET_DATA = {
    frames: {
        'pieSplat0001.png': {
            frame: { x: 309, y: 709, w: 230, h: 192 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 145, y: 5, w: 230, h: 192 },
            sourceSize: { w: 489, h: 372 },
            anchor: { x: 0.537359, y: 0.400538 }
        },
        'pieSplat0002.png': {
            frame: { x: 626, y: 439, w: 272, h: 238 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 106, y: 0, w: 272, h: 238 },
            sourceSize: { w: 489, h: 372 },
            anchor: { x: 0.537359, y: 0.400538 }
        },
        'pieSplat0003.png': {
            frame: { x: 309, y: 439, w: 315, h: 268 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 87, y: 2, w: 315, h: 268 },
            sourceSize: { w: 489, h: 372 },
            anchor: { x: 0.537359, y: 0.400538 }
        },
        'pieSplat0004.png': {
            frame: { x: 1, y: 373, w: 382, h: 306 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 53, y: 2, w: 382, h: 306 },
            sourceSize: { w: 489, h: 372 },
            anchor: { x: 0.537359, y: 0.400538 }
        },
        'pieSplat0005.png': {
            frame: { x: 492, y: 1, w: 436, h: 338 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 27, y: 2, w: 436, h: 338 },
            sourceSize: { w: 489, h: 372 },
            anchor: { x: 0.537359, y: 0.400538 }
        },
        'pieSplat0006.png': {
            frame: { x: 1, y: 1, w: 489, h: 370 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 2, w: 489, h: 370 },
            sourceSize: { w: 489, h: 372 },
            anchor: { x: 0.537359, y: 0.400538 }
        },
        'pieSplat0007.png': {
            frame: { x: 541, y: 713, w: 202, h: 205 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 154, y: 2, w: 202, h: 205 },
            sourceSize: { w: 489, h: 372 },
            anchor: { x: 0.537359, y: 0.400538 }
        },
        'pieSplat0008.png': {
            frame: { x: 541, y: 713, w: 202, h: 205 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 154, y: 2, w: 202, h: 205 },
            sourceSize: { w: 489, h: 372 },
            anchor: { x: 0.537359, y: 0.400538 }
        },
        'pieSplat0009.png': {
            frame: { x: 541, y: 713, w: 202, h: 205 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 154, y: 2, w: 202, h: 205 },
            sourceSize: { w: 489, h: 372 },
            anchor: { x: 0.537359, y: 0.400538 }
        }
    },
    animations: {
        animation: [
            'pieSplat0001.png',
            'pieSplat0002.png',
            'pieSplat0003.png',
            'pieSplat0004.png',
            'pieSplat0005.png',
            'pieSplat0006.png',
            'pieSplat0007.png',
            'pieSplat0008.png',
            'pieSplat0009.png'
        ]
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.0',
        image: PIE_BOMB_SPLAT_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 916, h: 916 },
        scale: '0.5',
        smartupdate: '$TexturePacker:SmartUpdate:22fec69edf9dc6b9f662773fc856b2c9:61ab44b6e1b7af33a468dba00410cc2a:952d1dcbdb9918ff5950e86b68905109$'
    }
};
